import styled from 'styled-components';
import { AccordionSummary } from '@mui/material';

export const Content = styled.div`
  word-break: break-word !important;
  .MuiAccordion-root.Mui-expanded {
    margin: 0 !important;
  }
  .MuiPaper-root.MuiAccordion-root {
    box-shadow: unset;
  }
  .MuiAccordion-root:before {
    display: none;
  }
  .MuiAccordionDetails-root {
    padding: 8px 16px !important;
  }
`;

export const ContainerBox = styled(AccordionSummary)`
  background: #fff !important;
  padding: 0 5px !important;

  p {
    color: ${({ theme }) => theme.pantoneBlack} !important;
  }
  span {
    color: ${({ theme }) => theme.pantone2726C} !important;
  }
`;

export const AreaPrice = styled.div``;

export const ContainerAccordionSummary = styled(AccordionSummary)`
  display: grid !important;
  grid-template-columns: 1fr 35px !important;
  grid-template-rows: 1fr !important;
  grid-column-gap: 0px !important;
  grid-row-gap: 0px !important;
  background: #fff !important;
  padding: 0 5px !important;
  p {
    color: ${({ theme }) => theme.pantoneBlack} !important;
  }
  span {
    color: ${({ theme }) => theme.pantone2726C} !important;
  }
  .MuiIconButton-root {
    width: 100% !important;
  }
`;

export const ContentAccordionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: 100%;
  word-wrap: break-word;
`;

export const BoxAccordionDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentPartsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;

  > strong {
    margin-bottom: -4px;
  }
`;

export const BoxDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
`;

export const ContainerBodyHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 250px;
  overflow: auto;
`;

export const LinkHistory = styled.a`
  &&& {
    text-decoration: underline;
    color: #3f5ec9;
  }
`;

